<skitbs-template [title]="v('menu_prepaid')">

    <form #formEdit="ngForm">
        <div *ngIf="modelXBVO != null">

            <!-- I. Prepaid-Status -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <div class="Wid100">
                        <b>{{v('state')}}</b>
                        <i class="pi pi-refresh Gray MarH Fright" (click)="onSearch()"></i>
                    </div>
                </ng-template>

                <div class="d-table">
                    <div>
                        <div class="d-cell-simple">{{v('yourPrepaidSaldoIs')}}</div>
                        <div class="TexAlCenter FontBold BsFsLarge">
                            <span class="{{normalizeZero(modelXBVO.currentVSaldo) >= 0 ? 'Green' : 'Red'}}">
                                {{modelXBVO.currentVSaldo | number:'.2-2' }}€
                            </span>
                        </div>
                    </div>
                    <div *ngIf="!modelXBVO.chargePrerequisites.tgOrderNotBlocked">
                        <div class="d-cell-simple">{{v('ordersAreBlocked')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-exclamation-circle Red BsFsLarge"></i></div>
                    </div>
                    <div
                        *ngIf="!modelXBVO.chargePrerequisites.cpIbanValid || !modelXBVO.chargePrerequisites.cpSepaActive">
                        <div class="d-cell-simple">{{v('bankAccountNotValid')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-exclamation-circle Red BsFsLarge"></i></div>
                    </div>
                    <div *ngIf="modelXBVO.chargePrerequisites.cpIbanValid">
                        <div class="d-cell-simple">{{v('bankAccountValid')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-check-circle Green BsFsLarge"></i></div>
                    </div>
                    <div *ngIf="modelXBVO.chargePrerequisites.cpSepaActive">
                        <div class="d-cell-simple">{{v('yourSepaMandateIsValid')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-check-circle Green BsFsLarge"></i></div>
                    </div>
                    <div *ngIf="modelXBVO.chargePrerequisites.contractValid">
                        <div class="d-cell-simple">{{v('yourContractIsValid')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-check-circle Green BsFsLarge"></i></div>
                    </div>
                    <div *ngIf="!modelXBVO.chargePrerequisites.contractValid">
                        <div class="d-cell-simple">{{v('yourContractIsExpired')}}</div>
                        <div class="TexAlCenter"><i class="pi pi-exclamation-circle Red BsFsLarge"></i></div>
                    </div>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>


            <!-- II. Charge once  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-plus-circle MarH"></i><b>{{v('oneTimeCharge')}}</b>
                </ng-template>

                <!-- top-up already running -->
                <div *ngIf="!modelXBVO.chargePrerequisites.chargeNotRunning" style="padding-bottom: 10px;"
                    class="d-flex">
                    <div class="d-col">{{v('chargingProcessRunning')}}</div>
                </div>

                <!-- top-up not running -->
                <div class="OvAuto">
                    <p innerHtml="{{v('dauerbestellungText')}}"></p>
                    <div class="MarAutoOnMobile" style="display: flex;">
                        <button pButton label="25€" icon="pi pi-plus-circle"
                            [disabled]="!modelXBVO.chargePrerequisites.chargeEnabled"
                            class="PadWithBorder10 MarR BsWid100p " (click)="onChargeOnce(25)"></button>
                        <button pButton label="50€" icon="pi pi-plus-circle"
                            [disabled]="!modelXBVO.chargePrerequisites.chargeEnabled"
                            class="PadWithBorder10 MarH BsWid100p " (click)="onChargeOnce(50)"></button>
                        <button pButton label="75€" icon="pi pi-plus-circle"
                            [disabled]="!modelXBVO.chargePrerequisites.chargeEnabled"
                            class="PadWithBorder10 MarH BsWid100p " (click)="onChargeOnce(75)"></button>
                        <button pButton label="100€" icon="pi pi-plus-circle"
                            [disabled]="!modelXBVO.chargePrerequisites.chargeEnabled"
                            class="PadWithBorder10 MarL BsWid100p " (click)="onChargeOnce(100)"></button>
                    </div>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>


            <!-- III. Auto-Charge  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-cog MarH"></i><b>{{v('autoCharge')}}</b>
                </ng-template>
                <div style="padding-bottom: 10px;">
                    <!-- Autocharge NOT active  -->
                    <div *ngIf="normalizeZero(modelXBVO.autoChargeAmount)==0" class="d-flex">
                        <div class="d-col">
                            <span>{{v('autochargeNotActiveText')}}.</span>
                            <div class="EmptyBox10"></div>
                            <span>{{v('dauerbestellungText')}}</span>
                            <div class="EmptyBox10"></div>
                            <div
                                innerHtml="{{v('autochargeSettingsText2') | stringFormat : modelXBVO.autochargeThreshold}}">
                            </div>
                        </div>
                    </div>
                    <!-- Autocharge ACTIVE  -->
                    <span *ngIf="normalizeZero(modelXBVO.autoChargeAmount)>0">{{v('autochargeSettingsText') |
                        stringFormat : modelXBVO.autochargeThreshold:modelXBVO.autoChargeAmount }}.</span>
                </div>

                <div class="OvAuto MarT">
                    <div class="MarAutoOnMobile" style="width: 330px;">
                        <button pButton label="50€" icon="pi pi-refresh"
                            [disabled]="!modelXBVO.chargePrerequisites.changeSettingsEnabled"
                            class="PadWithBorder10 MarR BsWid100p {{modelXBVO.autoChargeAmount==50 ? 'GreenBack' : ''}}"
                            (click)="onSetAutocharge(50)"></button>
                        <button pButton label="75€" icon="pi pi-refresh"
                            [disabled]="!modelXBVO.chargePrerequisites.changeSettingsEnabled"
                            class="PadWithBorder10 MarH BsWid100p {{modelXBVO.autoChargeAmount==75 ? 'GreenBack' : ''}}"
                            (click)="onSetAutocharge(75)"></button>
                        <button pButton label="100€" icon="pi pi-refresh"
                            [disabled]="!modelXBVO.chargePrerequisites.changeSettingsEnabled"
                            class="PadWithBorder10 BsWid100p MarL {{modelXBVO.autoChargeAmount==100 ? 'GreenBack' : ''}}"
                            (click)="onSetAutocharge(100)"></button>
                        <div class="EmptyBox10"></div>
                        <button pButton [label]="v('stopAutocharge')"
                            [disabled]="!modelXBVO.chargePrerequisites.changeSettingsEnabled || modelXBVO.autoChargeAmount == 0"
                            style="width: 320px;" class="PadWithBorder5" (click)="onSetAutocharge(0)"></button>
                    </div>
                </div>
            </p-panel>
            <div class="EmptyBox30"></div>


            <!-- IV. History  -->
            <p-panel styleClass="MarV">
                <ng-template pTemplate="header">
                    <i class="pi pi-list MarH"></i><b>{{v('balanceHistory')}}</b>
                </ng-template>

                <p-table [value]="modelXBVO.saldoChange" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Datum</th>
                            <th>Type</th>
                            <th>Saldo</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-pRow>
                        <tr>
                            <td class="">{{dateFormat(pRow.changeDate, 'dd.MM.')}}</td>
                            <td class="">{{ve('EnumSaldoChangeType', pRow.changeType.toString())}}</td>
                            <td class="TexAlRight">{{pRow.changeAmount}}€</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-panel>
            <div class="EmptyBox30"></div>
        </div>

    </form>
</skitbs-template>